import { tiendasApi } from '../api'

export const productosSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getProductos: builder.mutation({
            query: ({token}) => ({
                url: 'web/productos',
                method: 'GET',
                headers: {
                    'Authorization': token,
                }
            })
        }),
    })
})

export const {
    useGetProductosMutation,
} = productosSlice